export default __webpack_public_path__ + "static/media/mobilefood-logo.20f123fc.png";